import api from 'api'
import {
  ADVISOR_CLIENTS_RECEIVED,
  ADVISOR_CLIENTS_UNLOADED
} from './types'

// redux actions

export const clientsReceived = clients => ({
  type: ADVISOR_CLIENTS_RECEIVED,
  data: clients
})

export const clientsDataUnload = () => ({
  type: ADVISOR_CLIENTS_UNLOADED
})

export const unloadClients = () => dispatch => {
  dispatch(clientsDataUnload())
}

// thunk actions
export const getClients = () => dispatch => 
  api.bmc.advisor.getClients().then(res =>{ 
    dispatch(clientsReceived(res))
  })